import React from 'react';
import Icon from '../../../components/AppIcon';

const SalesMetrics = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <div className="bg-card rounded-lg p-4 border border-border">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Today's Sales</span>
          <Icon name="DollarSign" size={20} className="text-success" />
        </div>
        <p className="text-2xl font-bold text-foreground">
          ${stats?.totalSales?.toFixed(2) || '0.00'}
        </p>
      </div>

      <div className="bg-card rounded-lg p-4 border border-border">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Transactions</span>
          <Icon name="ShoppingCart" size={20} className="text-primary" />
        </div>
        <p className="text-2xl font-bold text-foreground">
          {stats?.transactionCount || 0}
        </p>
      </div>

      <div className="bg-card rounded-lg p-4 border border-border">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Avg Transaction</span>
          <Icon name="TrendingUp" size={20} className="text-accent" />
        </div>
        <p className="text-2xl font-bold text-foreground">
          ${stats?.averageTransaction?.toFixed(2) || '0.00'}
        </p>
      </div>
    </div>
  );
};

export default SalesMetrics;